"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get TASK_STATUS_OPTIONS () {
        return TASK_STATUS_OPTIONS;
    },
    get TASK_STATUS_TO_LABEL () {
        return TASK_STATUS_TO_LABEL;
    }
});
const _constants = require("../constants");
const TASK_STATUS_TO_LABEL = {
    [_constants.TASK_STATUS.TO_DO]: "To do",
    [_constants.TASK_STATUS.IN_PROGRESS]: "In progress",
    [_constants.TASK_STATUS.COMPLETE]: "Complete"
};
const TASK_STATUS_OPTIONS = Object.values(_constants.TASK_STATUS).map((value)=>({
        value,
        label: TASK_STATUS_TO_LABEL[value]
    }));

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3V0aWxzL3Rhc2tzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFRBU0tfU1RBVFVTIH0gZnJvbSBcIi4uL2NvbnN0YW50c1wiO1xuXG5leHBvcnQgY29uc3QgVEFTS19TVEFUVVNfVE9fTEFCRUw6IFJlY29yZDxUQVNLX1NUQVRVUywgc3RyaW5nPiA9IHtcbiAgW1RBU0tfU1RBVFVTLlRPX0RPXTogXCJUbyBkb1wiLFxuICBbVEFTS19TVEFUVVMuSU5fUFJPR1JFU1NdOiBcIkluIHByb2dyZXNzXCIsXG4gIFtUQVNLX1NUQVRVUy5DT01QTEVURV06IFwiQ29tcGxldGVcIixcbn07XG5cbmV4cG9ydCBjb25zdCBUQVNLX1NUQVRVU19PUFRJT05TID0gT2JqZWN0LnZhbHVlcyhUQVNLX1NUQVRVUykubWFwKHZhbHVlID0+ICh7XG4gIHZhbHVlLFxuICBsYWJlbDogVEFTS19TVEFUVVNfVE9fTEFCRUxbdmFsdWVdLFxufSkpO1xuIl0sIm5hbWVzIjpbIlRBU0tfU1RBVFVTX09QVElPTlMiLCJUQVNLX1NUQVRVU19UT19MQUJFTCIsIlRBU0tfU1RBVFVTIiwiVE9fRE8iLCJJTl9QUk9HUkVTUyIsIkNPTVBMRVRFIiwiT2JqZWN0IiwidmFsdWVzIiwibWFwIiwidmFsdWUiLCJsYWJlbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7UUFRYUE7ZUFBQUE7O1FBTkFDO2VBQUFBOzs7MkJBRmU7QUFFckIsTUFBTUEsdUJBQW9EO0lBQy9ELENBQUNDLHNCQUFXLENBQUNDLEtBQUssQ0FBQyxFQUFFO0lBQ3JCLENBQUNELHNCQUFXLENBQUNFLFdBQVcsQ0FBQyxFQUFFO0lBQzNCLENBQUNGLHNCQUFXLENBQUNHLFFBQVEsQ0FBQyxFQUFFO0FBQzFCO0FBRU8sTUFBTUwsc0JBQXNCTSxPQUFPQyxNQUFNLENBQUNMLHNCQUFXLEVBQUVNLEdBQUcsQ0FBQ0MsQ0FBQUEsUUFBVSxDQUFBO1FBQzFFQTtRQUNBQyxPQUFPVCxvQkFBb0IsQ0FBQ1EsTUFBTTtJQUNwQyxDQUFBIn0=